import React from "react"
import { Box } from "@mui/material"
import { ARIA_LABELS, LAYOUT } from "@/shared/components/image-gallery/constants"
import { ImageGalleryItem } from "@/shared/components/image-gallery/types"

interface ThumbnailStripProps {
  items: ImageGalleryItem[]
  currentIndex: number
  onSelect: (index: number) => void
}

const ThumbnailStrip: React.FC<ThumbnailStripProps> = ({ items, currentIndex, onSelect }) => {
  if (items.length <= 1) return null

  return (
    <Box
      sx={{
        width: LAYOUT.thumbnailStripWidth,
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        alignItems: "center",
        pt: 1,
        gap: 0.75,
        overflowY: "auto",
        flexShrink: 0,
        "&::-webkit-scrollbar": { width: 0 }
      }}>
      {items.map((item, idx) => (
        <Box
          key={item.id ?? `${item.url}-${idx}`}
          component="img"
          src={item.url}
          alt={item.alt ?? ARIA_LABELS.image(idx, items.length)}
          tabIndex={0}
          role="button"
          aria-label={ARIA_LABELS.thumbnail(idx, items.length)}
          aria-pressed={idx === currentIndex}
          onClick={() => onSelect(idx)}
          onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault()
              onSelect(idx)
            }
          }}
          sx={{
            width: LAYOUT.thumbnailSize,
            height: LAYOUT.thumbnailSize,
            zIndex: 1,
            objectFit: "cover",
            cursor: "pointer",
            border: idx === currentIndex ? "2px solid #e53935" : "2px solid transparent",
            borderRadius: 0.5,
            flexShrink: 0,
            transition: "border-color 0.2s"
          }}
        />
      ))}
    </Box>
  )
}

export default ThumbnailStrip
